import { client } from '../../../shared/services/apiClient';

export const verifyEmail = async (hash: string): Promise<any> => {
  return client(false, false).get(`/auth/verify-email/${hash}`);
};
